/**
 * @deprecated use i18n instead
 */
export enum ErrorMessage {
    // Auth
    NOT_AUTHORISED_ACCOUNT_INACTIVE = 'Niet geautoriseerd, account is niet actief',
    INVALID_TOKEN = 'Token is ongeldig',

    // Invalid
    EMAIL_INVALID = 'Geen geldig e-mailadres ingevuld',

    ORGANIZATION_NOT_FOUND = 'Organisatie niet gevonden',
    EMPLOYEE_NOT_FOUND = 'Medewerker niet gevonden',
    SOURCE_NOT_FOUND = 'Bron niet gevonden',

    // Failed creation
    EMPLOYEE_CREATION_FAILED = 'Medewerker kon niet worden aangemaakt',
    NOTE_CREATION_FAILED = 'Notitie kon niet worden aangemaakt',
    TEAM_CREATION_FAILED = 'Team kon niet worden aangemaakt',

    // Failed update
    EMPLOYEE_UPDATE_FAILED = 'Medewerker kon niet worden bijgewerkt',
    ACTIONPOINT_UPDATE_FAILED = 'Actiepunt kon niet worden bijgewerkt',
    TEAM_UPDATE_FAILED = 'Team kon niet worden bijgewerkt',

    // Failed deletion
    EMPLOYEE_REMOVAL_FAILED = 'Medewerker kon niet worden verwijderd',

    // Failed fetch
    PRIORITIES_FETCH_FAILED = 'Prioriteiten konden niet worden opgehaald',
    EMPLOYEES_FETCH_FAILED = 'Medewerkers konden niet worden opgehaald',
    EMPLOYEE_TEAMS_FETCH_FAILED = 'Teams van medewerker konden niet worden opgehaald',

    // Files
    FILES_CANT_LOAD = 'Bestanden konden niet worden geladen',
    FILE_CANT_DOWNLOAD = 'Bestand kon niet worden gedownload',
    FILE_CANT_EXTRACT_CONTENT = 'Bestandsinhoud kon niet geretourneerd worden',
    DIRECTORY_CANT_LOAD = 'Mapinhoud kon niet geladen worden',

    // Error pages
    ERROR_OTHER = 'Er is een fout opgetreden.'
}
